// _parallaxAnimations.js

import { getGSAP } from './_gsap.js';

export function initParallaxAnimations() {
  const gsap = getGSAP();
  
  // Sélectionnez tous les éléments avec l'attribut data-animation="parallax"
  const elements = document.querySelectorAll('[data-animation="parallax"]');
  
  elements.forEach(element => {
    // Récupérez les paramètres personnalisables
    const speed = parseFloat(element.dataset.speed) || 1; // Vitesse par défaut : 1
    const direction = element.dataset.direction || 'vertical'; // Direction par défaut : vertical
    const reverse = element.dataset.reverse === 'true'; // Inverser la direction
    const ease = element.dataset.ease || 'none'; // Easing par défaut : linéaire
    const start = element.dataset.start || 'top bottom'; // Position de départ du déclencheur
    const end = element.dataset.end || 'bottom top'; // Position de fin du déclencheur

    // Calculez la distance de déplacement en fonction de la vitesse et de la direction
    const distance = speed * 100;
    
    // Configurez l'animation en fonction de la direction
    let fromProps = {};
    let toProps = {};
    if (direction === 'horizontal') {
      toProps.x = reverse ? `-${distance}%` : `${distance}%`;
    } else { // vertical
      toProps.y = reverse ? `-${distance}%` : `${distance}%`;
    }
    
    // Créez l'animation de parallaxe
    gsap.fromTo(element, fromProps, {
      ...toProps,
      ease: ease,
      scrollTrigger: {
        trigger: element,
        start: start,
        end: end,
        scrub: true,
      }
    });
  });
}